import { withTranslation } from 'react-i18next';
import { Card, CardBody, Row, Table } from 'reactstrap';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { translations } from '../../action';
import { formatUtcDate } from '../../../../helpers/format';

const render = (card, isLoading) => (
  <>
    <div className="d-flex align-items-center justify-content-between">
      <span className="fs-4 fw-semibold">{card.heading}</span>
      {card?.description ?? null}
    </div>

    {isLoading ? (
      <div className="skeleton card" style={{ height: '100px' }} />
    ) : (
      <Card className="mt-1 p-0">
        <CardBody className="p-0">
          <Table className="table table-striped m-0 text-dark">
            <tbody>
              {card.table.map(({ label, value, extra }, key) => (
                <tr key={`sidebar-consumer-${++key}`}>
                  <td className="fw-semibold" style={{ width: '40%' }}>
                    {label}
                  </td>
                  <td className={extra ? 'd-flex justify-content-between' : ''}>
                    <span className="text-break">{value}</span>
                    <span>{extra ?? null}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    )}
  </>
);

const GeneralInfo = (props) => {
  const { audit, isLoading } = useSelector(
    createSelector(
      (store) => store.Audit,
      (slice) => ({
        isLoading: slice.isLoading,
        audit: slice.audit,
      })
    )
  );

  if (!audit) {
    return <div></div>;
  }

  const consumer = {
    heading: props.t('audit-management.heading'),
    table: [
      {
        label: props.t('audit-management.table.email'),
        value: audit?.email ?? '-',
      },
      {
        label: props.t('audit-management.table.action'),
        value: (
          <span
            className={`badge rounded-pill ${translations[audit?.action]?.color}`}
          >
            {translations[audit?.action]?.label}
          </span>
        ),
      },
      {
        label: props.t('audit-management.table.origin'),
        value: audit?.origin ?? '-',
      },
      {
        label: props.t('audit-management.table.microservice'),
        value: audit?.microservice ?? '-',
      },
      {
        label: props.t('audit-management.table.module'),
        value: audit?.module ?? '-',
      },
      {
        label: props.t('audit-management.table.ip'),
        value: audit?.ip ?? '-',
      },
      {
        label: props.t('audit-management.table.path'),
        value: audit?.path ?? '-',
      },
      {
        label: props.t('audit-management.table.created_at'),
        value: formatUtcDate(audit?.createdAt),
      },
    ],
  };

  return (
    <Row className="g-3">
      {render(consumer, isLoading)}
    </Row>
  );
};

export default withTranslation()(GeneralInfo);
